import { getSupportEmail } from 'projects/assets/constant/email';

const getDefaultErrorMessage = (): string => `An error occurred while processing your request, please contact ${getSupportEmail()}.`;
const getPermissionErrorMessage = (): string => `An error occurred while fetching user permissions, please try again later or contact ${getSupportEmail()}.`;
const getErrorWhileLoggingInMessage = (): string => `An error occurred while login, please contact ${getSupportEmail()}`;
const getTfaDeactivatedErrorMessage = (): string => `User has been deactivated. Please contact ${getSupportEmail()}`;
const getReactionUnavailableMessage = (): string => `Reaction is not available. Please contact ${getSupportEmail()}.`;

export let defaultErrorMessage = getDefaultErrorMessage();
export let unauthorizedAccessResourceErrorMessage = 'You don\'t have access of this resource.';
export let permissionErrorMessage = getPermissionErrorMessage();
export let ErrorWhileLoggingInMessage = getErrorWhileLoggingInMessage();
export let TfaDeactivatedError = getTfaDeactivatedErrorMessage();
export let CoworkerDetailReponseError = 'Unable to process request, due to invalid user detail(s).';

export const getNotImplementedAccountMessage = (): string =>
  `This functionality is not currently available, please contact ${getSupportEmail()}`;

export enum NotImplementedFunctionality {
  Corp = 'This functionality is not currently available, please contact Product team.'
}
export let reactionUnavailableMessage = getReactionUnavailableMessage();
export let noAdultCapacityTypeErrorMessage = "Unable to onboard product, due to invalid capacity type.";

export const refreshErrorKeyMessages = (): void => {
  defaultErrorMessage = getDefaultErrorMessage();
  permissionErrorMessage = getPermissionErrorMessage();
  ErrorWhileLoggingInMessage = getErrorWhileLoggingInMessage();
  TfaDeactivatedError = getTfaDeactivatedErrorMessage();
  reactionUnavailableMessage = getReactionUnavailableMessage();
};

export enum AuthorizationError {
  AccessTokenEmpty = 'Access token is not available.',
  RefreshTokenEmpty = 'Refresh token is not available.',
  Failed = 'Authorization has failed. Please reload to try to initiate authorization again.',
  AccessDenied = 'You are not authorised to access this resource. Please contact your programme administrator to request this feature.'
}

export enum ProductError {
  NotAvailable = 'The product is not available to book.',
  NotEnoughBalance = 'You’ll be able to book travel when you have $750 in your wallet.',
  LoadProductDetailsMessage = `We’re having trouble retrieving the latest details for this product from the marketplace provider. It may be temporarily unavailable or no longer for sale.`,
  LoadProductDetailsTitle = `Whoops! We couldn't load this product`
}

